module.exports = __webpack_public_path__ + "static/media/p.6f9e3e2a.jpg";